import React from "react";

const stakingFaq = [
  {
    title: "How much ETH do I need to stake?",
    description: (
      <p>
        The amount of ETH you need to stake depends on the requirements of the
        particular staking platform you choose to use. Currently, the minimum
        amount of ETH required to stake on the Ethereum 2.0 network is 32 ETH,
        which is equivalent to roughly $70,000 to $80,000 USD (as of March
        2023). However, there are some staking services that allow users to pool
        their ETH with other users to meet the minimum staking requirement,
        which can make staking more accessible to smaller investors. These
        staking pools usually require a minimum contribution, which can be much
        lower than the 32 ETH minimum. It&apos;s important to do your research
        and understand the requirements and risks associated with staking before
        investing any amount of ETH
      </p>
    ),
  },
  {
    title: "How often will I receive the ETH staking rewards?",
    description: (
      <p>
        You'll receive your ETH staking rewards weekly—every Monday. However,
        rewards are only distributed once your staked ETH joins a completed
        staking queue of 32 ETH, the minimum required to activate a validator.
        You can easily track your earnings in the Funds section of your BF
        account while we manage all the technical details for you.
      </p>
    ),
  },
  {
    title: "Where will I receive my ETH staking reward?",
    description: (
      <p>
        Once you begin staking ETH on the BF platform, staking rewards are
        distributed every Monday. Rewards are based on the overall performance
        of our validators and evenly shared among staking users. Your rewards
        will appear in the funds section of your account, where you can keep,
        withdraw, or convert them (e.g., into BTC). For convenience, we also
        offer an auto-restake feature, allowing you to automatically re-stake
        your rewards each Monday for compounding benefits. Please note, rewards
        are not guaranteed and depend on Ethereum network activity.
      </p>
    ),
  },
  {
    title: "How do I use ETH staking to own more Bitcoin?",
    description: (
      <p>
        It is not possible to use ETH staking to directly own more Bitcoin. ETH
        staking involves locking up ETH to participate in the Ethereum network
        and earn staking rewards. These rewards are paid out in ETH, not
        Bitcoin. However, you can use the staking rewards earned from ETH
        staking to buy more Bitcoin. This can be done by withdrawing your
        staking rewards to an exchange that supports the trading pair of ETH/BTC
        and using the ETH to buy Bitcoin. Keep in mind that the value of both
        cryptocurrencies can fluctuate, and trading involves risk. It&apos;s
        important to do your research and understand the market before making
        any investment decisions. However, you could stake your ETH to earn
        rewards in the form of additional ETH and then use those rewards to
        purchase Bitcoin via the BF platform. Keep in mind that this approach
        involves taking on the risk of price volatility for both ETH and
        Bitcoin. It&apos;s important to do your research and understand the
        risks before investing in any cryptocurrency.
      </p>
    ),
  },
  {
    title: "What fees does BF charge for using its ETH staking services?",
    description: (
      <p>
        BF charges a 20% fee on staking rewards, shared equally with our staking
        partner, Figment. This fee is automatically deducted from your earned
        rewards.
        <br />
        <br />
        You can reduce this fee by opting for Time-lock Staking, where fees
        decrease the longer you commit your stake. The longer the lock period,
        the lower the fee—down to 15% for the maximum term.
        <br />
        <br />
        These fees help cover platform operations, user support, and the
        distribution of staking rewards. BF remains fully transparent—there are
        no hidden charges. You can view the full fee schedule&nbsp;
        <b>
          <a href="https://bnktothefuture.com/fees">here</a>
        </b>
        .
      </p>
    ),
  },
  {
    title:
      "Is it Possible to Withdraw ETH at Any Time from BF's Staking Platform?",
    description: (
      <p>
        Yes, you can request withdrawals for your staked ETH. However, please
        note that there is an internal queueing system that pools a total of 32
        ETH from investors who want to unstake their ETH from an active
        validator set.
      </p>
    ),
  },
];

export default stakingFaq;
